import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';
import { CrossSellMultiselectComponent } from './cross-sell-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        CrossSellMultiselectComponent
    ],
    exports: [
        CrossSellMultiselectComponent
    ]
})
export class CrossSellMultiselectModule { }
